import type { IImage } from 'types/index';

export const enum PaymentType {
  Cash = 'ch',
  CardCourier = 'cc',
  CardOnline = 'co',
}

export const enum PaymentStatus {
  New = 1,
  Incomplete = 2,
  Approved = 3,
  Complete = 4,
  Failed = 5,
  Processed = 7,
}

export interface IOrder {
  name: string;
  phone: string;
  comment: string;
  latitude: number;
  longitude: number;
  total: number;
  total_dlv: number;
  status_id: number;
  created_at: string;
  updated_at: string;
  user_id: number | null;
  is_sync: boolean;
  store_id: number;
  transaction_id: string;
  payment_type: PaymentType;
  bonus_phone: number | null;
  is_pickup: boolean;
  sync_id: number | null;
  email: string;
  cutlery_qty: number;
  change_from: number | null;
  delivery_date: string | null;
  promo_code: string | null;
  payment_status: PaymentStatus;
  hash: string;
  promo_code_params: string;
  push_device_type: null;
  push_device_id: null;
  user_discount: number;
  client: string;
  http_referer: string;
  utm: string;
  delivery_with_card: string;
  delivery_without_card: string;
  synced_at: string;
  partner_id: number | null;
  wm_id: number | null;
  click_id: number | null;
  is_notified: boolean;
  phone_hashed: string;
  fallback_sended: boolean;
  payment_success_at: string;
  store_address: string | null;
  currency: string;
  charity_points: boolean;
  courier_tips: null;
  delivery_date_last: string;
  order_id: number | null;
  short_hash: string;
  status: string;
  items: IOrderItem[];
  cpa_pixel: string;
  viewed: boolean;
  address: {
    full: string;
    city: string;
    district: string;
    street: string;
    house: string;
    building: string;
    entrance: number;
    apartment: string;
    floor: number;
  };
}
export interface IOrderItem {
  id: number;
  order_id: number;
  product_id: number;
  parent_id: number | null;
  price: number;
  qty: number;
  title: string;
  price_orig: number;
  discount_rule_id?: number;
  is_gift: boolean;
  is_user_gift: boolean;
  is_complectation: boolean;
  images?: IImage[];
}
